export default function (/**@type {ApisauceInstance} */ api) {
  const getAllCee = (paging) => api.get(`Cee/search`, paging);
  const getAllCeeTasks = (paging) => api.get(`Survey/cee-rate-tasks`, paging);
  const getAllCeeSpots = (paging) =>
    api.get(`Survey/cee-spot-check-tasks`, paging);
  const getAllMeets = (paging) =>
    api.get(`Survey/monthly-meeting-tasks`, paging);

  const addCee = (payload) => api.post(`Cee/create`, payload);

  const getCee = (id) => api.get(`Cee/get/${id}`);

  const editCee = ({ payload, id }) => api.put(`Cee/edit/${id}`, payload);

  const deleteCee = (id) => api.delete(`Cee/delete/${id}`);

  return {
    Cee: {
      getAllCee,
      getCee,
      addCee,
      editCee,
      deleteCee,
      getAllCeeTasks,
      getAllCeeSpots,
      getAllMeets,
    },
  };
}
